import { mainServer } from "../../variables/config"

const useChat = () => {

    const onGetAll = async(params) => {
        const logData = JSON.parse(localStorage.getItem('data'))
        mainServer.instance.defaults.headers.common['Authorization'] = logData.token
        let response
        response = await mainServer.instance.get("/aichat/all", {params:params})
        return response.data.data.ai_chats
    }

    const onGet = async(id) => {
        const logData = JSON.parse(localStorage.getItem('data'))
        if(!logData) return null
        mainServer.instance.defaults.headers.common['Authorization'] = logData?.token
        let response
        response = await mainServer.instance.get(`/aichat/${id}`)
        return response.data.data.ai_chat
    }

    const onAdd = async(data2send) => {
        const logData = JSON.parse(localStorage.getItem('data'))
        mainServer.instance.defaults.headers.common['Authorization'] = logData.token
        let response
        response = await mainServer.instance.post(`/aichat`, data2send)
        console.log(response.data.data)
        //return response.data.data.ai_chats
        return response.data.data.ai_chat_id
    }

    const onAddMessage = async(id, data2send) => {
        const logData = JSON.parse(localStorage.getItem('data'))
        mainServer.instance.defaults.headers.common['Authorization'] = logData.token
        let response
        response = await mainServer.instance.post(`/aichat/${id}/message`, data2send)
        console.log(response.data.data)
        
    }

    const onRetryMessage = async(id) => {
        const logData = JSON.parse(localStorage.getItem('data'))
        mainServer.instance.defaults.headers.common['Authorization'] = logData.token
        let response
        response = await mainServer.instance.post(`/aichat/${id}/retry`)
        console.log(response.data.data)
        
    }

    return {
        onGetAll,
        onGet,
        onAddMessage,
        onAdd,
        onRetryMessage
    };
}
 
export default useChat;